import React from "react";
import { connect } from "react-redux";
import {Button, Row, Col, ModalFooter} from "reactstrap";
import { Field, reduxForm, FieldArray,formValueSelector } from "redux-form";
import { Card, CardHeader, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import { filter } from 'lodash';
import { withTranslation } from 'react-i18next';
import "react-dropdown/style.css";

import CreateNewFaultForm from "./CreateNewFaultForm";
import renderSelectField from '../../../../../shared/components/form/Select';
import renderDatePickerField from "../../../../../shared/components/form/DatePicker";
import {
  createLabel, createNewLabelToggle
} from "../../../../../redux/actions/feedbackActions";

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = "Please enter the Job Description name";
  }
  return errors;
};

const renderField =
  ({
     input, placeholder, type, meta: { touched, error },
   }) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
      <input {...input} placeholder={placeholder} type={type} />
      {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
  );

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderField.defaultProps = {
  placeholder: '',
  meta: null,
  type: 'text',
};

const renderTypeList = ({ fields, meta: { error, submitFailed } }, props) => {
  const allFields = fields.getAll();
  const fieldsName = fields.name;
  const {
    t,
    labelManager,
    corrected_event_type,
  } = props;

  function createOptions (labels) {
    let label_options = [{ value: 'CREATE_NEW', label: 'Create New' }];
    if(labels && labels.length > 0) {
      filter(labels, label => {
        label_options.push({ value: label.name, label: label.name });
      });
    }

    return label_options;
  }

  function buildFaultLabels(labelManager)  {
    if (!labelManager) {
      return [];
    }
    let labels =
      labelManager && labelManager.fault_labels &&
      labelManager.fault_labels.label_list;
    return createOptions(labels);
  }

  function buildFailureLabels(labelManager)  {
    if (!labelManager) {
      return [];
    }
    let labels =
      labelManager && labelManager.failure_prediction_labels &&
      labelManager.failure_prediction_labels.label_list;
    return createOptions(labels);
  }

  function buildMaintenanceLabels(labelManager)  {
    if (!labelManager) {
      return [];
    }
    let labels =
      labelManager && labelManager.maintenance_action_labels &&
      labelManager.maintenance_action_labels.label_list;
    return createOptions(labels);
  };

  function buildCorrectEventLabels(cevent_type, labelManager)  {
    if (!cevent_type) {
      return [];
    }
    let labels = [];
    if (labelManager) {
      if(cevent_type.value === "ANOMALY"){
        labels = labelManager.anomaly_labels.label_list;
      } else if(cevent_type.value === "FAULT"){
        labels = labelManager.fault_labels.label_list;
      } else if(cevent_type.value === "FAILURE_PREDICTION"){
        labels = labelManager.failure_prediction_labels.label_list;
      } else if(cevent_type.value === "HEALTH_PREDICTION"){
        labels = labelManager.health_prediction_labels.label_list;
      }
    }
    return createOptions(labels);
  };

  const corrected_label_options=buildCorrectEventLabels(corrected_event_type, labelManager);

  const FAULT_LABEL_OPTION =  buildFaultLabels(labelManager);

  const FAILURE_TYPE_OPTION =  buildFailureLabels(labelManager);

  const MAINTENANCE_ACTION_OPTION =  buildMaintenanceLabels(labelManager);

  const SEVERITY_OPTIONS = [
    { value: 'MAJOR', label: 'MAJOR' },
    { value: 'CRITICAL', label: 'CRITICAL' },
    { value: 'MINOR', label: 'MINOR' },
    { value: 'NORMAL', label: 'NORMAL' },
  ];

  const AI_DECISION_OPTIONS = [{ value: 'ACCURATE', label: 'Accurate' },
    { value: 'SOMEWHAT_ACCURATE', label: 'Somewhat Accurate' },
    { value: 'SOMEWHAT_INCORRECT', label: 'Somewhat Incorrect' },
    { value: 'INCORRECT', label: 'Incorrect' }];

  function renderFields(param, index) {
    if(param.label === "severity") {
      return (
        <div className="form__form-group-field">
          <Field
            component={renderSelectField}
            name={`${fieldsName}.[${index}]value`}
            placeholder="Severity"
            type="select"
            options={SEVERITY_OPTIONS}
          />
        </div>
      );
    }

    if(param.key === "ai_decision_quality") {
      return (
        <div className="form__form-group-field">
          <Field
            component={renderSelectField}
            name={`${fieldsName}.[${index}]value`}
            placeholder="AI Decision Quality"
            type="select"
            options={AI_DECISION_OPTIONS}
          />
        </div>
      );
    }

    if(param.key === "corrected_severity") {
      return (
        <div className="form__form-group-field">
          <Field
            component={renderSelectField}
            name={`${fieldsName}.[${index}]value`}
            placeholder="Corrected Severity"
            type="select"
            options={SEVERITY_OPTIONS}
          />
        </div>
      );
    }

    if(param.key === "corrected_label") {
      return (
        <div className="form__form-group-field">
          <Field
            component={renderSelectField}
            name={`${fieldsName}.[${index}]value`}
            placeholder="Corrected Label"
            type="select"
            options={corrected_label_options}
            onChange={onItemSelect}
          />
        </div>
      );
    }

    if(param.label === "fault_label") {
      return (
        <div className="form__form-group-field">
          <Field
            component={renderSelectField}
            name={`${fieldsName}.[${index}]value`}
            placeholder="Fault label"
            type="select"
            options={FAULT_LABEL_OPTION}
            onChange={onItemSelect}
          />
        </div>
      );
    }

    if(param.label === 'failure_type') {
      return (
        <div className="form__form-group-field">
          <Field
            component={renderSelectField}
            name={`${fieldsName}.[${index}]value`}
            placeholder='Failure Type'
            type="select"
            options={FAILURE_TYPE_OPTION}
            onChange={onItemSelect}
          />
        </div>
      );
    }

    if(param.label === 'maintenance_action') {
      return (
        <div className="form__form-group-field">
          <Field
            component={renderSelectField}
            name={`${fieldsName}.[${index}]value`}
            placeholder='Maintenance Action'
            type="select"
            options={MAINTENANCE_ACTION_OPTION}
            onChange={onItemSelect}
          />
        </div>
      );
    }

    if(param.label === "date_detected") {
      return (
        <div className="form__form-group-field">
          <Field
            name={`${fieldsName}.[${index}]value`}
            component={renderDatePickerField}
          />
          <div className="form__form-group-icon">
            <i className="fa fa-calendar"></i>
          </div>
        </div>
      );
    }

    return (
      <div className="form__form-group-field">
        <Field
          component={renderField}
          name={`${fieldsName}.[${index}]value`}
          value={ param.value }
          type="text"
        />
      </div>
    );
  }

  function onItemSelect(res)  {
    if(res.value === "CREATE_NEW"){
      props.createNewLabelToggle(!props.isCreateNewLabel);
    }
  };

  if (allFields && Object.keys(allFields).length > 0) {
    return allFields.map((param, index) =>  {
      return (
        <div key={index} className="form__form-group">
          <span className="form__form-group-label input-as-label">
            <span className="form__form-group-label">
              { t(`feedback_form_label.${param.key}`) }
            </span>
          </span>
          { renderFields(param, index) }
        </div>
      )
    });
  }

  return <React.Fragment />
};

let FeedbackForm = props => {
  const {
    t,
    handleSubmit,
    submitting,
    initialValues,
    feedback_type,
    corrected_event_type,
    labelManager
  } = props;
  const hasFeedback = initialValues && Object.keys(initialValues).length;

  const FEEDBACK_TYPE_OPTIONS = [
    { value: 'MAINTENANCE', label: 'MAINTENANCE' },
    { value: 'FAULT_REPORT', label: 'FAULT REPORT' },
    { value: 'FAILURE_REPORT', label: 'FAILURE REPORT' },
  ];

  function setFeedbackType(val) {
    let feedbackType = '';
    switch (val) {
      case 'AI_FEEDBACK':
        feedbackType='ai_feedback';
        break;
      case 'MAINTENANCE':
        feedbackType='maintenance_feedback';
        break;
      case 'FAULT_REPORT':
        feedbackType='fault_feedback';
        break;
      case 'FAILURE_REPORT':
        feedbackType='failure_feedback';
        break;
      case 'NO_ACTION':
        feedbackType='no_action';
        break;
      default:
        feedbackType='maintenance_feedback';
        break;
    }
    return feedbackType;
  }

  function handleCreateNewLabel(labelData, isCreateNewLabel,feedback_type) {
    if(labelData) {
      let data ={};
      if (feedback_type.value =="FAULT_REPORT"){
        data["ai_type"] = "FAULT";
      } else if (feedback_type.value =="FAILURE_REPORT"){
        data["ai_type"] = "FAILURE_PREDICTION";
      } else if (feedback_type.value =="MAINTENANCE"){
        data["ai_type"] = "MAINTENANCE_ACTION";
      } else if (feedback_type.value =="AI_FEEDBACK"){
        data["ai_type"] = corrected_event_type.value;
      } else{
        return;
      }
      data["label_list"]=[labelData];
      data["label_manager_id"] =labelManager._id;
      props.createLabel(data);
    }
    props.createNewLabelToggle(isCreateNewLabel);
  }

  return (
    <Card>
      <form onSubmit={handleSubmit}>
        <Row>
          <Col xs="12" className="form form--horizontal">

            <div className="form__form-group">
              <span className="form__form-group-label">
                  {t('asset_management.feedback_label.feedback_type')}
              </span>
              <div className="form__form-group-field">
                <Field
                  component={renderSelectField}
                  name="feedback_type"
                  placeholder="Feedback Type"
                  type="select"
                  options={FEEDBACK_TYPE_OPTIONS}
                />
              </div>
            </div>

            <FieldArray name={setFeedbackType(feedback_type.value)} component={ (fields) => renderTypeList(fields,props)} />

            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('asset_management.feedback_label.comments')}
              </span>
              <div className="form__form-group-field">
                <Field
                  component={renderField}
                  name="comments"
                  placeholder="comments"
                  type="text"
                />
              </div>
            </div>

            <div className="col-md-12">
              <Button
                type="submit"
                className="icon"
                color="success"
              >
                <p>Save</p>
              </Button>
            </div>

          </Col>
        </Row>
      </form>

      <CreateNewFaultForm
        handleCreateLabelToggle={handleCreateNewLabel}
        feedback_type={feedback_type}
        isToggleModal={props.isCreateNewLabel}
      />
    </Card>
  );
};

function mapStateToProps(state, ownProps) {
  const { form_data, labelManager } = ownProps;
  let newFormData = form_data && Object.keys(form_data).length > 0 ? form_data : {};

  let feedback_type = selector(state, "feedback_type");
  feedback_type = feedback_type || { value: 'FAILURE_REPORT', label: 'FAILURE REPORT' };
  let corrected_event_type = selector(state, "corrected_event_type");
  if (!corrected_event_type){
    corrected_event_type = form_data.corrected_event_type;
  }

  if (newFormData && newFormData.formType && newFormData.formType === "clone") {
    delete newFormData._id;
  }
  return {
    initialValues: newFormData,
    feedback_type,
    corrected_event_type,
    isCreateNewLabel : state.feedback.isCreateNewLabel,
    labelManager,
  };
}

let FeedbackData = reduxForm({
  validate: validate,
  form: "FeedbackForm",
  enableReinitialize: true
})(FeedbackForm);

const selector = formValueSelector('FeedbackForm');

export default withTranslation('common') (
  connect( state =>
    mapStateToProps,
    { createNewLabelToggle, createLabel }
  )
  (FeedbackData)
);
